module.exports = require('./../../environments/publicAPIKeys.' + process.env.NODE_ENV + '.json');


// WEBPACK FOOTER //
// ./htdocs/content/themes/tpt-national/assets/js/modules/Config/Config.js